import { BlocksIcon } from "lucide-react";
import React from "react";

const GenerationEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center p-2 py-4 gap-4 w-full">
      <div className="bg-secondary-300 rounded-xl p-4 border border-secondary-600">
        <BlocksIcon className="w-10 h-10 text-secondary-700 stroke-1" />
      </div>
      <div className="font-bold text-sm flex text-center text-secondary-900">
        No story generation in progress
      </div>
      <div className="font-medium text-xs text-secondary-800 flex text-center">
        To get started, select an action from the plus icon at the top.
      </div>
    </div>
  );
};

export default React.memo(GenerationEmptyState);
